
    import './styles.scoped.css';
    export default {
  "drawer": "awsui_drawer_12i0j_1jrk3_189",
  "legacy": "awsui_legacy_12i0j_1jrk3_204",
  "last-opened": "awsui_last-opened_12i0j_1jrk3_212",
  "drawer-global": "awsui_drawer-global_12i0j_1jrk3_217",
  "drawer-hidden": "awsui_drawer-hidden_12i0j_1jrk3_221",
  "drawer-content-container": "awsui_drawer-content-container_12i0j_1jrk3_224",
  "drawer-close-button": "awsui_drawer-close-button_12i0j_1jrk3_232",
  "drawer-content": "awsui_drawer-content_12i0j_1jrk3_224",
  "drawer-content-hidden": "awsui_drawer-content-hidden_12i0j_1jrk3_242",
  "drawer-slider": "awsui_drawer-slider_12i0j_1jrk3_245"
};
  